import PropTypes from 'prop-types';

export function RoleImage({ src, alt, size }) {
  const extraStyles = {};

  if (size) {
    extraStyles.width = `${size}px`;
    extraStyles.height = `${size}px`;
  }

  return <img src={src} alt={alt} style={extraStyles} />;
}

RoleImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  size: PropTypes.number,
};
